import { render, staticRenderFns } from "./noticeCcomponents.vue?vue&type=template&id=7c2a957b&scoped=true&class=full-height&"
import script from "./noticeCcomponents.vue?vue&type=script&lang=js&"
export * from "./noticeCcomponents.vue?vue&type=script&lang=js&"
import style0 from "./noticeCcomponents.vue?vue&type=style&index=0&id=7c2a957b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2a957b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c2a957b')) {
      api.createRecord('7c2a957b', component.options)
    } else {
      api.reload('7c2a957b', component.options)
    }
    module.hot.accept("./noticeCcomponents.vue?vue&type=template&id=7c2a957b&scoped=true&class=full-height&", function () {
      api.rerender('7c2a957b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/components/noticeCcomponents.vue"
export default component.exports